import { render, staticRenderFns } from "./assignExperts.vue?vue&type=template&id=1363a338&scoped=true&"
import script from "./assignExperts.vue?vue&type=script&lang=js&"
export * from "./assignExperts.vue?vue&type=script&lang=js&"
import style0 from "./assignExperts.vue?vue&type=style&index=0&id=1363a338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363a338",
  null
  
)

export default component.exports